/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import deferEditionModalParameters from './__generated__/DeferEditionModalComponentQuery$parameters';
import type { DeferEditionModalComponentQuery } from './__generated__/DeferEditionModalComponentQuery.graphql.ts';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
};

type JiraDeferEditionModalEntryPointComponent = EntryPointComponent<
	{
		deferEditionModal: DeferEditionModalComponentQuery;
	},
	{},
	{},
	{}
>;

export const jiraDeferEditionModalEntryPoint: EntryPoint<
	JiraDeferEditionModalEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<JiraDeferEditionModalEntryPointComponent>(
		/* webpackChunkName: "async-jira-defer-edition-modal" */ './DeferEditionModalComponent.tsx',
	),
	getPreloadProps: ({ cloudId, productKey }: EntryPointParams) => ({
		queries: {
			deferEditionModal: {
				parameters: deferEditionModalParameters,
				variables: { cloudId, productKey },
			},
		},
	}),
});
